var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrmIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4799 13.6605C26.3199 12.1205 21.8399 8.34049 21.8399 8.34049L20.9999 7.50049L20.0199 8.34049C20.0199 8.34049 15.6799 12.1205 9.3799 13.6605L8.3999 13.8005V14.9205C8.3999 23.3205 13.2999 31.5805 20.4399 35.2205L20.9999 35.5005L21.5599 35.2205C28.5599 31.7205 33.5999 23.4605 33.5999 14.9205V13.8005L32.4799 13.6605ZM21.0151 28.5002C20.1629 28.5002 19.4934 27.8002 19.4934 26.948C19.4934 26.0962 20.1934 25.3962 21.0456 25.3962C21.8977 25.3962 22.5673 26.0962 22.5673 26.9785C22.5369 27.8002 21.8369 28.5002 21.0151 28.5002ZM22.4151 15.4133C22.0803 14.7437 21.3499 14.3788 20.6195 14.5611C19.9195 14.7437 19.4325 15.444 19.4325 16.1741C19.4476 16.4165 19.4628 16.6662 19.4779 16.9159C19.4932 17.1683 19.5085 17.4206 19.5238 17.6654C19.5695 18.594 19.6228 19.5226 19.676 20.4511C19.7293 21.3792 19.7825 22.3071 19.8282 23.235C19.8586 23.8437 20.376 24.3309 20.9847 24.3309C21.6238 24.3309 22.1108 23.8437 22.1412 23.2049C22.1561 23.011 22.1637 22.8246 22.1712 22.6419C22.1789 22.4514 22.1865 22.265 22.2021 22.0785C22.2325 21.4848 22.2706 20.8835 22.3086 20.2822C22.3467 19.6814 22.3847 19.0806 22.4151 18.4875C22.4456 17.6959 22.476 16.935 22.5369 16.1741C22.5673 15.9306 22.5369 15.6567 22.4151 15.4133Z",
    fill: "#FF5630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmIconAlert);
export default __webpack_public_path__ + "static/media/irm-icon-alert.44bc62239e89858366b4730cf3dc7387.svg";
export { ForwardRef as ReactComponent };